export default __webpack_public_path__ + "static/media/your-worksite-preamble.28d5f83f.md";